// extracted by mini-css-extract-plugin
module.exports = {"container":"WeightInput-module__container--1pG2-","input":"WeightInput-module__input--1Fi2P","percentChar":"WeightInput-module__percentChar--1cGK5"};